// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_SA_header__3w5oX","headerHome":"Header_SA_headerHome__3InZz","align":"Header_SA_align__1SPIB"};